import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import JobsList from "../components/JobsList";
import Searchbar from "../components/Searchbar";
import { fetchJobs } from "../features/jobs/jobsSlice";

export default function Home() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchJobs());
  });
  return (
    <>
      <Searchbar />
      <JobsList />
    </>
  );
}
